import { ElementType, ReactNode } from 'react';
import Navigation, { NavigationProps } from './Navigation';
import Footer, { FooterProps } from './Footer';

export interface HomeLayoutProps<T extends ElementType> {
  footerItems?: FooterProps['sections'];
  navProps?: NavigationProps<T>;
  children: ReactNode;
}

function HomeLayout<T extends ElementType = 'button'>({
  footerItems = [],
  navProps = {},
  children,
}: HomeLayoutProps<T>) {
  return (
    <>
      <Navigation {...navProps} />
      <main>{children}</main>
      <Footer sections={footerItems} />
    </>
  );
}

export default HomeLayout;
